import React from 'react';

function LargeLogo(props) {
    return (
        <div className="nameContainer">
                <h3 id="largeName">Corked Up</h3>
        </div>
    );
}

export default LargeLogo;